import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_MERCADERIA_SECADA } from '../../../../config/tables'

function TablaDetalleMercaderiaSecadaView () {
  return (
    <MuiTable id={TABLA_DETALLE_MERCADERIA_SECADA} />
  )
}

export default TablaDetalleMercaderiaSecadaView
